import {
    ClientPendingTask,
    ClientPendingTaskType
} from '~/common/hooks/ClientPendingTask/client-pending-task.types';
import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
import {
    TCheckClientPendingTaskResponse,
    ICreateClientPendingTaskResponse
} from '~/types/server.types';
import {
    v2CheckClientPendingTasksPath,
    v2CreateClientPendingTaskPath
} from '~/utils/ts-routes.utils';

export class ClientPendingTaskAdapter extends BaseHttpAdapter {
    async createClientPendingTask<T extends ClientPendingTaskType>(
        type: T,
        data: ClientPendingTask[T]['taskData']
    ) {
        return this.apiService.apiRequest<ICreateClientPendingTaskResponse>({
            method: 'post',
            url: v2CreateClientPendingTaskPath(),
            data: {
                task_type: type,
                task_data: data
            }
        });
    }

    async cancelClientPendingTask(taskId: string, cancelMessage: string) {
        return this.apiService.apiRequest({
            method: 'delete',
            url: `/api/v2/client_pending_tasks/${taskId}`,
            data: { cancel_message: cancelMessage }
        });
    }

    async checkClientPendingTasksByIds(taskIds: string[]) {
        const data = { task_ids: taskIds };
        return this.apiService.apiRequest<TCheckClientPendingTaskResponse>({
            method: 'get',
            url: v2CheckClientPendingTasksPath(data)
        });
    }

    async checkClientPendingTaskByType(taskType: ClientPendingTaskType) {
        const data = {
            task_type: taskType,
            task_states: ['started', 'pending']
        };
        return this.apiService.apiRequest<TCheckClientPendingTaskResponse>({
            method: 'get',
            url: v2CheckClientPendingTasksPath(data)
        });
    }
}
